<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

<mat-toolbar>
    <h1>{{title}}</h1>
</mat-toolbar>

<section class="margin" [innerHTML]="content" blur-form-element></section>
